import { useAtom } from "jotai";
import type { JSX } from "react";
import { useState } from "react";

import { CouncilProfessionSubStep } from "@/components/flows/steps/council/components/council-profession-sub-step";
import { ALL_PROFESSIONS } from "@/components/flows/steps/council/utils/professions";
import { ProgressRoundedLayout } from "@/components/ui/layout/progress-rounded-layout";
import { useSubStepNavigation } from "@/hooks/use-sub-step-navigation";
import { councilStepAtom } from "@/lib/atoms/council-step-atom";
import { useFlowStepContext } from "@/lib/context/flow-step-context";

export const ProfessionPage = (): JSX.Element => {
  const { step, isLoading, progress, goBack } = useFlowStepContext();
  const [councilState, setCouncilState] = useAtom(councilStepAtom);
  const { goToSubStep } = useSubStepNavigation();

  const [filteredProfessions, setFilteredProfessions] = useState(ALL_PROFESSIONS);

  const handleContinue = () => {
    const selected = ALL_PROFESSIONS.find((p) => p.value === councilState.profession);
    goToSubStep(selected?.council ? "council" : "training-validation");
  };

  return (
    <ProgressRoundedLayout progress={progress} onBack={goBack}>
      <CouncilProfessionSubStep
        professions={ALL_PROFESSIONS}
        filteredProfessions={filteredProfessions}
        onSearch={setFilteredProfessions}
        defaultValue={councilState.profession ?? undefined}
        onChange={(value) => {
          const profession = ALL_PROFESSIONS.find((p) => p.value === value);
          const name = profession?.label ?? null;
          const acronym = profession?.council ?? null;
          setCouncilState((s) => ({ ...s, profession: value, professionName: name, councilAcronym: acronym }));
        }}
        title={step.configuracoes?.titulo ?? "Qual é a sua profissão?"}
        description={
          step.configuracoes?.descricao ?? "Selecione uma opção na lista abaixo"
        }
        buttonText={step.configuracoes?.textoBotao ?? "Continuar"}
        isLoading={isLoading}
        isValid={Boolean(councilState.profession)}
        onContinue={handleContinue}
      />
    </ProgressRoundedLayout>
  );
};
